import { Link } from 'react-router-dom';

const products = [
  {
    id: 1,
    title: '一綴り',
    subtitle: 'Hitotsuzuri',
    description:
      'PDFの分割・抽出・結合ができる、Windows向けデスクトップアプリです。\n個人・法人を問わず無料でご利用いただけます。',
    os: 'Windows 10 / 11 (64bit)',
    price: '無料',
    buttonText: '詳細',
    image:
      '/image/hitotsuzuri.png',
    link: '/hitotsuzuri',
  },
  {
    id: 2,
    title: 'MSK AIアシスタント',
    subtitle: 'Manual Support Knowledge',
    description:
      '社内のマニュアル、仕様書、FAQなどのナレッジデータを登録するだけで、AIが人間に代わって24時間365日、正確に自動回答するチャットボットシステムです。\n問い合わせ対応の自動化や、社内の仕様確認・引き継ぎ業務を効率化し、企業の労働生産性向上とDXを強力に推進します。',
    os: 'Webブラウザ（各種ホームページ、社内ポータルへの埋め込み対応）',
    price: 'お見積もり',
    buttonText: '詳細',
    image: '/image/msk-knowledge-ai-logo.png',
    link: '/msk-knowledge-ai',
  },
  {
    id: 3,
    title: 'Sesly',
    subtitle: 'SES Sales & Backoffice System',
    description:
      '営業担当者の毎月の事務負担を減らすために生まれた、「案件起点」のSES業務一元管理システムです。\n見積・注文・月次請求のPDF作成からGmail送信、案件継続の引き継ぎ、受領・入金チェック、売上分析までを一気通貫でカバー。貴社の業務に合わせてカスタマイズ提供いたします。',
    os: 'Webブラウザ（社内サーバー / クラウド導入・カスタマイズ対応）',
    price: 'お見積もり',
    buttonText: '詳細',
    image: '/image/sesly-icon.png',
    link: '/products/sesly',
  },
];

const ProductsItems = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="mb-14">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#5DAA68]/10">
              <i className="ri-box-3-line text-lg text-[#5DAA68]"></i>
            </div>
            <h4 className="text-2xl md:text-3xl font-bold text-[#89B56B] font-sans">
              製品一覧
            </h4>
          </div>
          <div className="border-t border-[#89B56B]/20"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array.isArray(products) &&
            products.map((product) => (
              <div
                key={product.id}
                className="h-full flex flex-col bg-white rounded-2xl shadow-[0_4px_24px_rgba(137,181,107,0.08)] overflow-hidden group hover:shadow-[0_8px_32px_rgba(137,181,107,0.15)] transition-all duration-300"
              >
                <div className="w-full h-[200px] overflow-hidden bg-white flex-shrink-0">
                  <img
                    src={product.image}
                    alt={product.title}
                    title={`${product.title} - MSK製品`}
                    className="w-full h-full object-contain object-center group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="px-6 py-5 flex flex-col flex-1">
                  <div className="mb-2">
                    <h3 className="text-base font-bold text-[#89B56B] group-hover:text-[#5DAA68] transition-colors">
                      {product.title}
                    </h3>
                    {product.subtitle && (
                      <p className="text-xs text-[#5DAA68] font-medium tracking-wide mt-1">
                        - {product.subtitle} -
                      </p>
                    )}
                  </div>
                  <p className="text-[13px] text-gray-600 leading-relaxed mb-4 whitespace-pre-line">
                    {product.description}
                  </p>
                  <div className="text-[13px] text-gray-500 mb-5 space-y-1">
                    <p>対応OS：{product.os}</p>
                    <p>料金：{product.price}</p>
                  </div>
                  <Link
                    to={product.link}
                    className="mt-auto flex items-center justify-center w-full h-11 rounded-md bg-[#89B56B] text-white text-sm font-bold hover:bg-[#5DAA68] transition-colors duration-300 cursor-pointer shadow-md whitespace-nowrap flex-shrink-0"
                  >
                    {product.buttonText}
                  </Link>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsItems;
